import { Checkbox, Label } from '@monksflow/monks-ui';
import type { ModelProviderResponseDto } from '@inference.engine/api-client';

interface ProviderWhitelistEditFormProps {
  allProviders: ModelProviderResponseDto[];
  selectedProviders: string[];
  onToggleProvider: (providerKey: string) => void;
  isPending: boolean;
}

export const ProviderWhitelistEditForm = ({
  allProviders,
  selectedProviders,
  onToggleProvider,
  isPending,
}: ProviderWhitelistEditFormProps) => {
  return (
    <div className="flex gap-0 items-start w-full">
      {allProviders.map((provider) => (
        <div key={provider.key} className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Checkbox
              id={`provider-whitelist-${provider.key}`}
              checked={selectedProviders.includes(provider.key)}
              onCheckedChange={() => onToggleProvider(provider.key)}
              disabled={isPending}
            />
            <Label
              htmlFor={`provider-whitelist-${provider.key}`}
              className="text-base leading-6 text-foreground"
            >
              {provider.name}
            </Label>
          </div>
        </div>
      ))}
    </div>
  );
};
